import { Directive, Input } from '@angular/core';
import { IContactPersonResponse, ImmomioIconName } from '../../models';

@Directive()
export class ContactDetailsBaseComponent {
  @Input() contact: IContactPersonResponse;
  public immomioIconName = ImmomioIconName;
}
